import campaignsApi from 'common/src/modules/campaigns/campaigns.api';
import refreshDashboards from 'common/src/modules/campaigns/store/insightsTab/actions/refreshDashboards';
import {ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import {CampaignAnalyticsToolName} from '../campaignAnalyticsAgent.enums';

const inputSchema = z.object({});

function createDashboardTool(store: CLStore) {
  async function execute(): Promise<ToolResult> {
    const state = store.getState();
    const {
      campaignPage: {
        campaignTree: {
          campaign: {id: campaignId},
        },
      },
    } = state;

    const dashboardId = await campaignsApi.createCampaignDashboard(campaignId);

    store.dispatch(refreshDashboards());

    return toolResult(`Dashboard created with id: ${dashboardId}`);
  }

  return tool({
    name: CampaignAnalyticsToolName.CreateDashboard,
    displayName: 'Creating dashboard',
    description: 'create a dashboard',
    execute,
    inputSchema,
  });
}

export default createDashboardTool;
